var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 48.042,
    viewBox: "0 0 40 48.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_373",
    "data-name": "Groupe 373",
    transform: "translate(-160.429 -222.195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_506-2",
    "data-name": "Groupe 506-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_503-2",
    "data-name": "Groupe 503-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_577",
    "data-name": "Trac\\xE9 577",
    d: "M194.429,270.236h-28a6.006,6.006,0,0,1-6-6v-36a6.007,6.007,0,0,1,6-6h.012c9.436.059,14.747,0,17.6-.028,3.555-.038,3.623-.039,4.274.612.408.407,5.136,6.359,6.05,7.514,6.063,7.662,6.063,7.753,6.063,8.623v25.279A6.007,6.007,0,0,1,194.429,270.236Zm-28.005-44a2,2,0,0,0-1.995,2v36a2,2,0,0,0,2,2h28a2,2,0,0,0,2-2V239.53c-1.459-2.04-8.434-10.826-10.492-13.338-.461,0-1.112.008-1.853.016C181.22,226.239,175.889,226.295,166.424,226.236Z",
    fill: "#9a96a7"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_578",
    "data-name": "Trac\\xE9 578",
    d: "M177.148,259.357a1.5,1.5,0,0,1-1.06-.439l-5.44-5.44a1.5,1.5,0,0,1,0-2.121l5.44-5.44a1.5,1.5,0,0,1,2.121,2.121l-4.379,4.379,4.379,4.38a1.5,1.5,0,0,1-1.061,2.56Z",
    fill: "#9a96a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_579",
    "data-name": "Trac\\xE9 579",
    d: "M183.708,259.356a1.5,1.5,0,0,1-1.06-2.56l4.379-4.379-4.379-4.38a1.5,1.5,0,0,1,2.121-2.121l5.44,5.44a1.5,1.5,0,0,1,0,2.121l-5.44,5.44A1.5,1.5,0,0,1,183.708,259.356Z",
    fill: "#9a96a7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.039a445e7055c4553413a807baa7eb32.svg";
export { ForwardRef as ReactComponent };